import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const PdpQuantitySelector = ({ bulkAddOptions, selectQuantity, selectedQuantity }) =>
  bulkAddOptions &&
  bulkAddOptions.length > 0 && (
    <>
      <div className="QuantitySelector_container">
        <div className="QuantitySelector__title">{I18n.localize('pdp.selectQuantity')}:</div>
        <div className="QuantitySelector__button_container">
          {bulkAddOptions.map(({ bulkAddAmount, title }) => (
            <button
              className={classNames('QuantitySelector__button', {
                'QuantitySelector__button--active': bulkAddAmount === selectedQuantity,
              })}
              onClick={() => selectQuantity(bulkAddAmount)}
              aria-label={title}
              key={`bulk-amount-${title}`}
              aria-pressed={`${bulkAddAmount === selectedQuantity}`}
            >
              <span className="QuantitySelector__button_title">{title}</span>
            </button>
          ))}
        </div>
      </div>
      <style jsx>
        {`
          .QuantitySelector_container {
            background-color: white;
          }
          .QuantitySelector__title {
            font-size: ${Theme.get('font-size-small-px')};
            font-weight: ${Theme.get('font-weight-semi-bold')};
            letter-spacing: ${Theme.get('letter-spacing-large-px')};
            padding-bottom: ${Theme.get('spacing') * 2}px;
            text-transform: uppercase;
            white-space: nowrap;
          }
          .QuantitySelector__button_container {
            display: flex;
            gap: ${Theme.get('spacing-px')};
            padding-bottom: ${Theme.get('spacing') * 4}px;
          }
          .QuantitySelector__button {
            appearance: none;
            background-color: ${Theme.get('colors-white')};
            border: 1px solid ${Theme.get('colors-black')};
            border-radius: ${Theme.get('border-radius-px')};
            color: ${Theme.get('colors-black')};
            cursor: pointer;
            font-size: ${Theme.get('font-size-description-px')};
            font-weight: ${Theme.get('font-weight-bold')};
            letter-spacing: ${Theme.get('letter-spacing-px')};
            min-height: ${Theme.get('spacing') * 8}px;
            padding: 0;
            outline: none;
            transition:
              background ${Theme.get('transition-timing-ease-in-out-quad')},
              ${Theme.get('transition-duration-fast-ms')};
            width: 100%;
          }
          .QuantitySelector__button:hover {
            background-color: ${Theme.get('colors-black-20')};
            color: ${Theme.get('colors-black')};
          }
          .QuantitySelector__button--active {
            background-color: ${Theme.get('colors-black')};
            color: ${Theme.get('colors-white')};
          }
          .QuantitySelector__button--active:hover {
            background-color: ${Theme.get('colors-black')};
            color: ${Theme.get('colors-white')};
          }

          .QuantitySelector__button_title {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
        `}
      </style>
    </>
  );

PdpQuantitySelector.propTypes = {
  selectQuantity: PropTypes.func.isRequired,
  selectedQuantity: PropTypes.number,
  bulkAddOptions: PropTypes.arrayOf(
    PropTypes.shape({
      bulkAddAmount: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
};

PdpQuantitySelector.defaultProps = {
  selectQuantity: () => {},
  bulkAddOptions: [],
};

export default PdpQuantitySelector;
